import UserManagement from "./Admin/UserManagement";
import AdminErrorBoundary from "../components/admin/AdminErrorBoundary";

const UserAdminPage = () => (
  <AdminErrorBoundary>
    <UserManagement />
  </AdminErrorBoundary>
);

export default UserAdminPage;
